export const getThreatRatingColor = (rating: number): string => {
  if (rating >= 4) return '#ff4d4f'; // Red for high threat
  if (rating >= 3) return '#faad14'; // Orange for medium threat
  return '#52c41a'; // Green for low threat
};

export const getThreatRatingIcon = (rating: number): string => {
  if (rating >= 4) return '🔴';
  if (rating >= 3) return '🟡';
  return '🟢';
};

export const getProjectCoordinates = (projectData?: any) => {
  if (projectData?.address?.location?.coordinates) {
    const [lng, lat] = projectData.address.location.coordinates;
    return { lat, lng };
  }
  return null;
};
